import AuthGuard from "app/auth/AuthGuard";
import SaAccessGuard from "app/auth/SaAccessGuard";
import NotFound from "app/views/sessions/NotFound";
import pagesRoutes from "app/views/pages/pagesRoutes";
import pageLayoutRoutes from "app/views/settings/PageLayoutRoutees";
import { dashboardRoutes } from "app/views/dashboard/DashboardRoutes";
import sessionRoutes from "app/views/sessions/SessionRoutes";
import MatxLayout from '../components/MatxLayout/MatxLayout'



export const AllPages = () => {

  const all_routes = [
    {
      path: "/",
      element: (
        <AuthGuard>
          <SaAccessGuard>
            <MatxLayout />
          </SaAccessGuard>
        </AuthGuard>
      ),
      children: [
        ...dashboardRoutes,
        ...pageLayoutRoutes,
        ...pagesRoutes,
      ],
    },
    ...sessionRoutes,
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  return all_routes;
}
